import { setComponentMapOverrides } from '@jutro/uiconfig';
import { PaymentDetailsPage } from 'gw-capability-quoteandbind-common-react';
import 'gw-capability-quoteandbind-farm-react';
import GWQuoteFARMPolicyDetailsPage from './pages/PolicyDetails/PolicyDetailsPage';
import { CommercialPackageDetails } from 'gw-capability-quoteandbind-common-react';

setComponentMapOverrides(
    {
        GWQuoteFARMPolicyDetailsPage: { component: 'GWQuoteFARMPolicyDetailsPage' },
        GWQuoteFARMPaymentDetailsPage: { component: 'GWQuoteFARMPaymentDetailsPage' },
        GWQuoteFARMCommercialDetailsPage: { component: 'GWQuoteFARMCommercialDetailsPage' }
    },
    {
        GWQuoteFARMPolicyDetailsPage,
        GWQuoteFARMPaymentDetailsPage: PaymentDetailsPage,
        GWQuoteFARMCommercialDetailsPage: CommercialPackageDetails
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as PEFARMWizard } from './PEFARMWizard';
